import { gql, TypedDocumentNode } from "@apollo/client";

import { QueryStackArgs } from "types/generated";

import { StackWithHooks } from "./types";

export const GET_STACK_HOOKS: TypedDocumentNode<StackWithHooks, QueryStackArgs> = gql`
  query GetStackHooks($id: ID!) {
    stack(id: $id) {
      id
      name
      afterApply
      afterDestroy
      afterInit
      afterPerform
      afterPlan
      afterRun
      beforeApply
      beforeDestroy
      beforeInit
      beforePerform
      beforePlan
      attachedContexts {
        contextHooks {
          afterApply
          afterDestroy
          afterInit
          afterPerform
          afterPlan
          afterRun
          beforeApply
          beforeDestroy
          beforeInit
          beforePerform
          beforePlan
        }
        contextId
        contextLabels
        contextName
        id
        isAutoattached
        priority
      }
    }
  }
`;
